import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Typography } from '@mui/material';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

interface MultiFileUploadContainerProps {
  onFileSelect: (files: File[]) => void;
}

const MultiFileUploadContainer: React.FC<MultiFileUploadContainerProps> = ({ onFileSelect }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    multiple: true,
    onDrop: (acceptedFiles) => {
      onFileSelect(acceptedFiles);
    },
  });

  return (
    <Box
      {...getRootProps()}
      sx={{
        height: '150px',
        border: '2px dashed #24272C90',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        padding: '20px',
      }}
    >
      <input {...getInputProps()} />
      <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <AddPhotoAlternateIcon sx={{ fontSize: '40px', color: '#6563FF', marginBottom: '8px' }} />
        <Typography variant="caption" sx={{ color: '#6563FF' }}>
          Drag & drop files here, or click to select
        </Typography>
      </Box>
    </Box>
  );
};

export default MultiFileUploadContainer;
